import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { ListColumn } from '../list/list-column.model';
import { UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import moment from 'moment';


@Component({
    selector: 'app-list-search-button-dates',
    templateUrl: './list-search-button-dates.component.html',
    styleUrls: ['./list-search-button-dates.component.scss'],
    standalone: false
})
export class ListSearchButtonDatesComponent implements OnInit {

  @Input() name: string = '';
  @Input() columns: ListColumn[] = [];
  @Input() addBut: boolean = false;
  @Input() searchBut: boolean = false;
  @Input() addDownload: boolean = false;
  @Input() button_name: string = '';
  @Input() hideFilter: boolean = false;
  @Input() dataInTable: boolean = false;
  @Input() maxDays: number = 0;

  @ViewChild('filter') filter: ElementRef | undefined;
  @Output() filterChange = new EventEmitter<any>();
  @Output() reportDownload = new EventEmitter<any>();

  @Input() hideHeader: boolean = false;
  @Input() filterArray: any = [{id: 0, name: ''}];
  @Input() hasFilter: boolean = false;
  form?: UntypedFormGroup;
  hasDates: boolean = false;

  @Output() filterComboChange = new EventEmitter<number>();
  today = new Date(); 
  maxDate = new Date(); 

  constructor(private fb: UntypedFormBuilder, ) {

  }
  ngOnInit(): void {
    this.form = this.fb.group({
      search: ['0', []],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
    });

    this.form.get("search")?.valueChanges.subscribe(x => {
      this.filterComboChange.emit(x);
   })

   this.form.get("startDate")?.valueChanges.subscribe(x => {
    if (x) {
      this.maxDate = x;
    }
  })

  }


  toggleColumnVisibility(column: any, event: any) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    column.visible = !column.visible;
  }

  sendSearchButton(){
    let momentStringStart = '';
    let momentStringEnd = '';
    if (this.form?.get('startDate')?.value) {
      let momentObj = moment(this.form?.get('startDate')?.value);
      momentStringStart = momentObj.format('YYYY-MM-DD')
    }
    if (this.form?.get('endDate')?.value) {
      let momentObj = moment(this.form?.get('endDate')?.value);
      momentStringEnd = momentObj.format('YYYY-MM-DD')
    }
    this.filterChange.emit({values: [momentStringStart, momentStringEnd], value: this.filter?.nativeElement.value});
  }

  sendReporthButton(){
    let momentStringStart = '';
    let momentStringEnd = '';
    if (this.form?.get('startDate')?.value) {
      let momentObj = moment(this.form?.get('startDate')?.value);
      momentStringStart = momentObj.format('YYYY-MM-DD')
    }
    if (this.form?.get('endDate')?.value) {
      let momentObj = moment(this.form?.get('endDate')?.value);
      momentStringEnd = momentObj.format('YYYY-MM-DD')
    }
    this.reportDownload.emit({values: [momentStringStart, momentStringEnd], value: this.filter?.nativeElement.value});
  }

  verifyStart() {
    if (this.form?.get('startDate')?.value) {
      let momentObj = moment(this.form?.get('startDate')?.value, 'YYYY-MM-DD').add(this.maxDays, 'days');
      return momentObj.toDate();
    }
    return this.today;
  }
}
